import { Button } from "@ronin/ui";
import { RotateCcw, WifiOff } from "lucide-react";

/** spec11 FR14: a page whose data was never loaded and cannot be loaded now. */
export function NeedsConnection({ onRetry }: { onRetry: () => void }) {
  return (
    <div
      role="status"
      className="flex flex-col items-center gap-3 border border-dashed border-input px-6 py-12 text-center"
    >
      <WifiOff className="size-6 text-dim-foreground" aria-hidden />
      <h2 className="text-sm font-semibold text-foreground">Needs a connection</h2>
      <p className="text-xs text-muted-foreground">This loads when you are online again.</p>
      <Button variant="secondary" size="sm" onClick={onRetry}>
        <RotateCcw />
        Try again
      </Button>
    </div>
  );
}
